import { createStore, compose, applyMiddleware } from 'redux'
import rootReducer from './reducers/rootReducer'
import { thunk } from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const loadState = () => {
    try {
        // Load the data saved in localStorage, against the key 'app_state'
        const serialisedState = window.localStorage.getItem('app_state');
        // If no data is saved, return undefined
        if (!serialisedState) return undefined;

        // De-serialise the saved state, and return it.
        return JSON.parse(serialisedState);
    } catch (err) {
        console.error('Error loading state from localStorage:', err);
        // Return undefined if localStorage is not available, 
        return undefined;
    }
};

const oldState = loadState();
export const store = createStore(rootReducer, oldState, composeEnhancers(applyMiddleware(thunk)));

// Select only essential state to persist (avoiding quota issues)
const selectStateToPersist = (state) => {
    return {
        ...state,
        defaults: {
            ...state.defaults,
            clientList: null
        }
    };
};

//save the data to localStorage
const saveState = (state) => {
    try {
        if (state === undefined) {
            console.log('Removing app_state from localStorage');
            localStorage.removeItem('app_state');
        } else {
            // Only persist essential state to avoid quota issues
            const stateToSave = selectStateToPersist(state);
            // console.log('Saving selected state to localStorage:', Object.keys(stateToSave));
            const serialisedState = JSON.stringify(stateToSave);
            localStorage.setItem('app_state', serialisedState);
            // console.log('State saved successfully to localStorage');
        }
    } catch(err) {
        console.error('Error saving state to localStorage:', err);
        console.error('State that failed to save:', state);
    }
};

// listener initialize onchange state
let saveStateTimeout;
store.subscribe(() => {
    // Debounce saves to avoid excessive localStorage writes
    if (saveStateTimeout) {
        clearTimeout(saveStateTimeout);
    }
    saveStateTimeout = setTimeout(() => {
        const currentState = store.getState();
        console.log('State changed, attempting to save...');
        saveState(currentState);
    }, 100);
});

export default store;